import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { animated } from "react-spring";

import { drawer } from "./drawer.module.scss";

const Drawer = ({ className, ...props }) => (
  <animated.section className={classNames(drawer, className)} {...props} />
);

Drawer.open = { transform: "translate3d(0%, 0, 0)" };
Drawer.closed = { transform: "translate3d(101.5%, 0, 0)" }; // yes, to make sure it's really offscreen
Drawer.initialVelocity = 5;

Drawer.propTypes = {
  className: PropTypes.string
};

Drawer.defaultProps = {
  className: ""
};

export default Drawer;
